import React from "react";
import { Card, CardBody, CardTitle, Row, Col } from "reactstrap";

const ImageList = ({ images }) => {
  return (
    <>
      <Card className="mb-4">
        <CardTitle tag="h5" style={{ paddingLeft: "10px", paddingTop: 10 }}>
          Images
        </CardTitle>
        <CardBody>
          <Row>
            {Object.entries(images).map(([key, imageUrl], index) => (
              <Col sm="6" key={index}>
                <p className="mb-2">
                  <i style={{ color: "#9d9c9c" }}>
                    <span
                      style={{
                        display: "inline-block",
                        width: "6em",
                        whiteSpace: "nowrap",
                        fontSize: "15px",
                      }}
                    >
                      {key} :
                    </span>
                  </i>
                  {imageUrl && imageUrl != null ? (
                    <a href={imageUrl} download>
                      {" "}
                      <i
                        style={{ fontSize: "20px" }}
                        className="bx bx-download"
                      ></i>
                    </a>
                  ) : (
                    <span></span>
                  )}
                </p>
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </>
  );
};

export default ImageList;
